import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, DialogConfig, DialogRef, InputModule, SelectModule } from '@sag-ui';
import { SharedModule } from '../../../shared/shared.module';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IPatchUser, IUser, Roles } from '@cod-monorepo/interfaces';

@Component({
    selector: 'app-edit-user-dialog',
    standalone: true,
    imports: [CommonModule, ButtonModule, SharedModule, ReactiveFormsModule, FormsModule, InputModule, SelectModule],
    templateUrl: './edit-user.component.html'
})
export class EditUserDialogComponent implements OnInit {
    public formGroup = new FormGroup({
        gid: new FormControl({ value: '', disabled: true }, Validators.required),
        firstName: new FormControl({ value: '', disabled: true }, Validators.required),
        lastName: new FormControl({ value: '', disabled: true }, Validators.required),
        email: new FormControl({ value: '', disabled: true }, Validators.required),
        roles: new FormControl<Roles[]>([], Validators.required)
    });
    public roles = Roles;

    constructor(public config: DialogConfig<IUser>, public dialogRef: DialogRef<IPatchUser>) {}

    ngOnInit(): void {
        this.patchForm();
    }

    public onClose(confirm: boolean): void {
        if (!confirm) {
            this.dialogRef.close();
        }

        this.dialogRef.close({
            roles: this.formGroup.get('roles')?.value ?? []
        });
    }

    public get invalid(): boolean {
        return this.formGroup.invalid;
    }

    private patchForm(): void {
        this.formGroup.patchValue(this.config.data as IUser);
    }
}
